// extracted by mini-css-extract-plugin
export default {"menuToogle":"menuToogle_menuToogle__90e1h","active":"menuToogle_active__YcHjk"};